import React, { ReactChild, ReactFragment, ReactPortal } from "react";
import { StyleButton } from "@components/Button/style";

interface IButtonProps {
  className?: string;
  children?:
    | ReactChild
    | ReactFragment
    | ReactPortal
    | boolean
    | null
    | undefined;
  onClick?: () => void;
  color?: string;
  bg?: string;
  type?: "button" | "submit" | "reset" | undefined;
}

const Button = ({
  className,
  children,
  onClick,
  type,
  color = "#FFFFFF",
  bg = "#0085C8",
}: IButtonProps) => (
  <StyleButton
    className={className}
    onClick={onClick}
    type={type}
    color={color}
    bg={bg}
  >
    {children}
  </StyleButton>
);

export default Button;
